const OrderOptions = {
  // 外卖平台（takeOutPlatform）
  channelEnumList: [
    { key: 'POS', value: '收银POS', img: '' },
    { key: 'MEITUAN_TAKEOUT', value: '美团外卖', img: require('@/images/dining-way-icon/ico_meituan@2x.png') },
    { key: 'ELE_TAKEOUT', value: '饿了么外卖', img: require('@/images/dining-way-icon/ico_eleme@2x.png') },
    { key: 'WECHAT_MINI_PROGRAM', value: '微信小程序', img: require('@/images/dining-way-icon/logo_kuaie_default_multicolor48.png') },
    { key: 'ALIPAY_MINI_PROGRAM', value: '支付宝小程序', img: require('@/images/dining-way-icon/logo_kuaie_default_multicolor48.png') },
    { key: 'JINGDONG_TAKEOUT', value: '京东外卖', img: require('@/images/dining-way-icon/logo_jingdong_multicolor48.png') },
    { key: 'DOUYIN_MINI_PROGRAM', value: '抖音小程序', img: require('@/images/dining-way-icon/ico_douyin@2x.png') },
    { key: 'CRM_BACKGROUND', value: 'CRM后台', img: '' },
    { key: 'DOUYIN_TAKEOUT', value: '抖音外卖', img: require('@/images/dining-way-icon/ico_douyin@2x.png') },
    { key: 'K_MOBILE', value: '掌上客如云', img: '' },
    { key: 'PAD', value: '平板点餐', img: '' },
    { key: 'OPEN_PLATFORM', value: '开放平台', img: '' },
    { key: 'WEB', value: '商家中心PC', img: '' },
  ],

  // 用餐方式（diningWay）
  eatTypeList: [
    { key: 'IN_SITE', value: '堂食', img: require('@/images/dining-way-icon/ico_tangshi@2x.png') },
    { key: 'TAKE_OUT', value: '外带', img: require('@/images/dining-way-icon/ico_waidai@2x.png') },
    { key: 'TAKE_AWAY', value: '外卖', img: require('@/images/dining-way-icon/logo_kuaie_default_multicolor48.png') },
    { key: 'RESERVATION', value: '堂食+稍后用餐', img: require('@/images/dining-way-icon/logo_kuaie_default_multicolor48.png') },
  ],

  // 订单类型（orderType）
  orderTypeList: [
    { key: 3, value: '单品订单' },
    { key: 10, value: '套餐订单' },
    { key: 8, value: '礼包订单' },
    { key: 2, value: '自提订单' },
    { key: 5, value: '盲盒订单' },
    // { key: 11, value: '拼团套餐订单' },
    // { key: 1, value: '加购线下订单' },
    { key: 4, value: '拼团订单' },
    // { key: 6, value: '加购订单' },
    // { key: 7, value: '加购礼包订单' },
    // { key: 9, value: '未定义' },
  ],

  // 订单来源（orderSource）
  orderSourceList: [
    { key: 'wxMiniAppCustom', value: '微信小程序' },
    { key: 'AlipayMiniAppCustom', value: '支付宝小程序' },
    { key: 'kry', value: '客如云' },
    { key: 'app', value: 'app小程序' },
    { key: 'h5', value: 'H5小程序' },
  ],

  // 订单状态（orderStatus）
  orderStatusList: [
    { key: -1, value: '待支付' },
    { key: 0, value: '待取餐' },
    { key: 1, value: '取餐中' },
    { key: 3, value: '已完成' },
    { key: 4, value: '已取消' },
  ],

  // 开票状态（isInvoice）
  invoiceStatusList: [
    { key: 0, value: '未开票' },
    { key: 1, value: '已开票' },
    { key: 66, value: '转人工开票' },
  ],

  // 支付状态（payStatus）
  payStatusList: [
    { key: 1, value: '已支付' },
    { key: 2, value: '待支付' },
    { key: 3, value: '支付失败' },
    { key: 4, value: '支付超时' },
  ],

  // 退款状态（refundStatus）
  refundStatusList: [
    { key: 0, value: '未退款' },
    { key: 1, value: '退款中' },
    { key: 2, value: '已退款' },
    { key: 3, value: '退款完成(终态)' },
    { key: 4, value: '退款失败(终态)' },
  ],

  // 支付方式（payChanel）
  payChanelList: [
    { key: 'WALLET_PAYMENT', value: '钱包支付' },
    { key: 'WX_JSAPI', value: '微信支付' },
    { key: 'ALIPAY_MINI_APP', value: '支付宝支付' },
  ],
};

export default OrderOptions;
